import { Delete } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import { ResponsiveRow } from "../../constants/layout.constants";
import MuiDataGrid from "./MuiDataGrid";
import ConfirmationModal from "../modals/confirmation";
import {
  deletePayBill,
  getPropertyPayBills,
  getVillasoftPayBills,
} from "../../services/subscription.service";
import AddEditPayBill from "../modals/addEditPayBill";
import { issueResponseMessage } from "../../actions/message";
import { sortJSONArray } from "../../util/util";
import { ModalAcceptButton } from "../../constants/component.constants";

const PayBillsTab = ({ payBillType }) => {
  const [payBills, setPayBills] = useState([]);
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedPayBill, setSelectedPayBill] = useState(null);
  const [addEditModal, setAddEditModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const loadPayBills = () => {
    setLoading(true);
    if (payBillType === "propertyPayBills") {
      getPropertyPayBills()
        .then((res) => {
          issueResponseMessage(res);
          setPayBills(res.data.sort(sortJSONArray("subscriber")));
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (payBillType === "villasoftPayBills") {
      getVillasoftPayBills()
        .then((res) => {
          issueResponseMessage(res);
          setPayBills(res.data.sort(sortJSONArray("payBill")));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    loadPayBills();
  }, [payBillType]);

  const handleAddEditClick = (payBill, action) => {
    // Handle view click logic here (e.g., open a modal to view details)
    setTask(action);
    setSelectedPayBill(payBill);
    setAddEditModal(true);
  };

  const handleAddEditModalClose = (reload) => {
    setAddEditModal(false);
    setTask(null);
    if (reload) {
      loadPayBills();
    }
  };

  const handleConfirmClose = () => {
    setConfirmDelete(false);
    setSelectedPayBill(null);
  };

  const handleDeleteClick = (payBill) => {
    setTask("Delete");
    setSelectedPayBill(payBill);
    setConfirmDelete(true);
  };

  const handleDelete = () => {
    setLoading(true);
    deletePayBill({ payBill: selectedPayBill.payBill })
      .then((res) => {
        loadPayBills();
        issueResponseMessage(res);
        handleConfirmClose();
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const propertyPayBillColumns = useMemo(
    () => [
      {
        headerName: "Facility",
        field: "facility",
        minWidth: 150,
        flex: 1.5,
      },
      {
        headerName: "Subscriber",
        field: "subscriber",
        minWidth: 200,
        flex: 2,
      },

      {
        headerName: "Active",
        field: "isActive",
        minWidth: 150,
        flex: 1.5,
        valueFormatter: (row) => {
          return row.value ? "Yes" : "No";
        },
      },
      { headerName: "PayBill", field: "payBill", minWidth: 100, flex: 1.5 },
    ],
    [],
  );

  const villasoftPayBillColumns = useMemo(
    () => [
      { headerName: "PayBill", field: "payBill", minWidth: 100, flex: 1.5 },
      {
        headerName: "Actions",
        field: "actions",
        width: 100,
        type: "actions",
        getActions: (params) => {
          let arr = [];
          arr.push(
            <GridActionsCellItem
              icon={<Delete />}
              onClick={() => handleDeleteClick(params.row)}
              label="Delete"
              showInMenu
            />,
          );
          return arr;
        },
      },
    ],
    [],
  );
  return (
    <>
      {payBillType === "villasoftPayBills" && (
        <ResponsiveRow>
          <ModalAcceptButton
            onClick={() => {
              handleAddEditClick(null, "Create");
            }}
            sx={{
              width: { xs: "100%", lg: "200px" },
            }}
          >
            Add Paybill
          </ModalAcceptButton>
        </ResponsiveRow>
      )}
      <ResponsiveRow>
        <MuiDataGrid
          dataGridColumns={
            payBillType === "propertyPayBills"
              ? propertyPayBillColumns
              : villasoftPayBillColumns
          }
          dataGridRows={payBills}
          loading={loading}
          height="65vh"
          totalRows={payBills ? payBills.length : 0}
          serverPagination={false}
          noSelection
        />
        {confirmDelete && (
          <ConfirmationModal
            showConfirmationModal={confirmDelete}
            handleConfirmationClose={handleConfirmClose}
            title={"Confirm PayBill Deletion"}
            severity={"warning"}
            body={`Are you sure you want to delete ${selectedPayBill.payBill}?`}
            positiveText={"Confirm"}
            negativeText={"Cancel"}
            positiveAction={handleDelete}
            negativeAction={handleConfirmClose}
            negativeActionText={"Cancel"}
          />
        )}
        {addEditModal && (
          <AddEditPayBill
            openModal={addEditModal}
            closeModal={handleAddEditModalClose}
            task={task}
            selectedPayBill={selectedPayBill}
          />
        )}
      </ResponsiveRow>
    </>
  );
};

export default PayBillsTab;
